import React from "react";
import { FaWindowClose } from "react-icons/fa";
import { Card, CardBody } from "reactstrap";

export default function ViewLanding({ Modalclose, modalData }) {
  if (!modalData) {
    return null; // or return some default content if modalData is null or undefined
  }
  return (
    <>
      <div className="modal-wrapper"></div>
      <div className="modal-container">
        <div className="modal-head">
          <h1>Webinar DETAILS</h1>
          <div className="close-icon">
            <FaWindowClose onClick={Modalclose} />
          </div>
        </div>
        <div className="modal-body">
          <Card>
            <CardBody>
              <section className="view-blog view-sec">
                <div className="container">
                  <div className="mt-3 view-text">
                    <label className="heading">Topic </label>
                    <p>{modalData.topic}</p>
                    <label className="heading">Web URL</label>
                    <p>{modalData.webiUrl}</p>
                    <label className="heading"> Date</label>
                    <p>{modalData.date}</p>
                    <label className="heading">Time</label>
                    <p>{modalData.time}</p>
                    <label className="heading">Path URL</label>
                    <p>{modalData.url}</p>

                    <label className="heading"> Description</label>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: modalData.description || "",
                      }}
                    />
                    {modalData.thumbnail_image && (
                      <>
                        <label className="heading">Events Image</label>

                        <img
                          src={`${modalData.thumbnail_image}?${Date.now()}`}
                          alt="Thumbnail"
                          style={{widht: "20px"}}
                        />
                      </>
                    )}
                    <label className="heading">Status</label>
                    <div className="status-details">
                      <span
                        className={`status ${
                          modalData.status ? "active" : "inactive"
                        }`}
                      >
                        {modalData.status ? "active" : "inactive"}
                      </span>
                    </div>
                  </div>
                </div>
              </section>
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
}
